module.exports = __webpack_public_path__ + "static/media/stand-off.1d57e48c.png";